export function formatDateLine(iso: string): string {
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const weekday = d.toLocaleDateString('en-GB', { weekday: 'short' });
    const rest = d.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
    return `${weekday}, ${rest}`;
  } catch {
    return '';
  }
}
